import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 代理品牌 列表頁
  {
    path: '/product',
    name: 'brand',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'brand-list' });
      },
      alias: "brand",
      title: '代理品牌'
    },
  },
  // 代理品牌 列表頁
  {
    path: '/product/brand',
    name: 'brand-list',
    component: () => lazyLoadView(import('@views/Brand/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const {
            filterClass = '',
            query = undefined,
          } = routeTo.query
          const params = {
            product_category_alias : filterClass.length
              ? filterClass.split(',')
              : undefined,
            search: query,
          }
          await store.dispatch('option/fetchOptionList', {
            types: ['product_parent_category'],
            useCached: true
          })
          const [
            currentBrandList,
          ] = await Promise.all([
            store.dispatch('brand/fetchBrands', {
              params
            }),
          ])
          // routeTo.params.breadcrumbTitle = '代理品牌';
          routeTo.params.currentBrandList = currentBrandList;
          // routeTo.params.currentProductCategory = currentProductCategory.product_parent_category;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌列表'
    },
    props: (route) => ({
      currentBrandList: route.params.currentBrandList || [],
      // currentProductCategory: route.params.currentProductCategory || [],
    })
  },
  // 代理品牌 內容頁
  {
    path: '/product/brand/:brandAlias',
    name: 'brand-item',
    component: () => import('@views/Brand/Item'),
    // component: () => lazyLoadView(import('@views/Brand/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          // const [ currentBrand ] = 
          await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            })
          ])

          // routeTo.params.currentBrand = currentBrand;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌'
    },
    props: (route) => ({
      // currentBrand : route.params.currentBrand || {},
    })
  },
  // 代理品牌 內容頁
  {
    path: '/product/brand/:brandAlias/introduce',
    name: 'brand-introduce',
    component: () => import('@views/Brand/Introduce/Index'),
    // component: () => lazyLoadView(import('@views/Brand/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          // const [ currentBrand ] = 
          await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            })
          ])
          // routeTo.params.currentBrand = currentBrand;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
          if(!store.state.brand.cachedBrand.description) {
            next({ name: '404' })
          }
          next() 
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌介紹'
    },
    props: (route) => ({
      // currentBrand : route.params.currentBrand || {},
    })
  },
  // 代理品牌 解決方案 列表頁
  {
    path: '/product/brand/:brandAlias/solution',
    name: 'brand-solution-list',
    component: () => lazyLoadView(import('@views/Brand/Solution/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('brand/fetchBrand', {
            brandAlias: routeTo.params.brandAlias
          })
          const tabs = store.state.brand.cachedBrand.tabs
          const result = tabs.some((item) => {
            return item.alias === 'solution'
          })
          if(!result) return next({ name: '404' })
          const { filterBrand = '', filterCategory = '', filterClass = '', query = undefined , page } = routeTo.query
          const params = {
            brand_alias: [routeTo.params.brandAlias],
            solution_category_alias: filterCategory.length
              ? filterCategory.split(',')
              : undefined,
            industry_category_alias: filterClass.length
              ? filterClass.split(',')
              : undefined,
            search: query,
            limit: 10,
            page: page,
          }
          const [currentList, tagsList] = await Promise.all([
            store.dispatch('article/fetchList', {
              contentAlias: 'solution',
              params
            }),
            store.dispatch('global/fetchKeyword', { hot: 1 })
          ])
          routeTo.params.currentList = currentList.items;
          routeTo.params.pagination = currentList.pagination;
          routeTo.params.tagsList = tagsList;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
          // routeTo.params.breadcrumbTitle = currentList.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-解決方案列表'
    },
    props: (route) => ({
      currentList: route.params.currentList,
      pagination: route.params.pagination,
      tagsList: route.params.tagsList
    })
  },
  // 代理品牌 解決方案 內容頁
  {
    path: '/product/brand/:brandAlias/solution/:solutionAlias',
    name: 'brand-solution-item',
    component: () => import ('@views/Brand/Solution/Item'),
    // component: () => lazyLoadView(import('@views/Brand/Solution/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [currentBrand, currentItem] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            }),
            store.dispatch('article/fetchItem', {
              contentType: 'solution',
              alias: routeTo.params.solutionAlias,
              brand: routeTo.params.brandAlias,
            })
          ])
          // routeTo.params.currentBrand = currentBrand;
          routeTo.params.defaultValue = currentItem.items;
          // routeTo.params.breadcrumbTitle = currentItem.title;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '解決方案'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      // currentBrand : route.params.currentBrand || {},
    })
  },
  // 代理品牌 產品系列 列表頁
  {
    path: '/product/brand/:brandAlias/product',
    name: 'brand-product-list',
    component: () => lazyLoadView(import('@views/Brand/Product/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('brand/fetchBrand', {
            brandAlias: routeTo.params.brandAlias
          })
          const tabs = store.state.brand.cachedBrand.tabs
          const result = tabs.some((item) => {
            return item.alias === 'product'
          })
          if(!result) return next({ name: '404' })
          const { filterCategory = '', query = undefined, page = 1, orderBy= '' } = routeTo.query
          const statusMap =  [
            {
              alias: 'newest',
              query: {
                orderBy: 'created_at',
                order: 'desc' 
              }
            },
            {
              alias: 'oldest',
              query: {
                orderBy: 'created_at',
                order: 'asc' 
              }
            },
            {
              alias: 'asc',
              query: {
                orderBy: 'title',
                order: 'asc' 
              },
            },
            {
              alias: 'desc',
              query: {
                orderBy: 'title',
                order: 'desc' 
              }
            }
          ]
          const currentStatus = statusMap.filter((item) => {
            return item.alias === orderBy
          })
          const params = {
            brand_alias: [routeTo.params.brandAlias],
            product_category_alias: filterCategory.length
              ? filterCategory.split(',')
              : undefined,
            search: query,
            limit: 10,
            page,
            orderBy: currentStatus[0]? currentStatus[0].query.orderBy : undefined,
            order: currentStatus[0]? currentStatus[0].query.order : undefined,
          }
          const [currentList] = await Promise.all([
            store.dispatch('product/fetchList', params)
          ])
          // const {items, total} = await store.dispatch('product/fetchList', params)
          // routeTo.params.list = items;
          // routeTo.params.total = total;
          routeTo.params.currentList = currentList.items;
          routeTo.params.pagination = currentList.pagination;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
          // routeTo.params.breadcrumbTitle = currentList.title;
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-產品系列列表'
    },
    props: (route) => ({
      list: route.params.currentList,
      pagination: route.params.pagination,
    })
  },
  // 代理品牌 產品系列 內容頁
  {
    path: '/product/brand/:brandAlias/product/:productAlias',
    name: 'brand-product-item',
    component: () => import('@views/Brand/Product/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brandAlias, productAlias } = routeTo.params
          const [currentBrand, currentItem] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: brandAlias
            }),
            store.dispatch('product/fetchItem', productAlias)
          ]);

          routeTo.params.defaultValue = currentItem;
          // routeTo.params.breadcrumbTitle = currentItem.title;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '產品管列'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    })
  },
  // 代理品牌 品牌新訊/促銷訊息 列表頁
  {
    path: '/product/brand/:brandAlias/news',
    name: 'brand-news-list',
    // component: () => lazyLoadView(import('@views/Brand/News/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('brand/fetchBrand', {
          brandAlias: routeTo.params.brandAlias
        })
        const tabs = store.state.brand.cachedBrand.tabs
        const result = tabs.filter((item) => {
          return item.alias === 'news'
        })
        if(result[0] && !!result[0].children) {
          const promotion = result[0].children.some((item) => {
            return item.alias === 'promotion'
          })
          if(promotion) {
            next({    
              name: 'brand-news-category',
              params: {
                categoryAlias: 'promotion',
                brandAlias: routeTo.params.brandAlias
              }
            })
          } else {
            next({    
              name: 'brand-news-category',
              params: {
                categoryAlias: 'bulletin',
                brandAlias: routeTo.params.brandAlias
              }
            })
          }
        } else {
          return next({ name: '404' })
        }
        
      
      },
      alias: "brand",
      title: '代理品牌-最新消息列表'
    },
  },
  // 代理品牌 品牌新訊/促銷訊息 分類頁
  {
    path: '/product/brand/:brandAlias/news/:categoryAlias',
    name: 'brand-news-category',
    component: () => lazyLoadView(import('@views/Brand/News/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('brand/fetchBrand', {
            brandAlias: routeTo.params.brandAlias
          })
          const tabs = store.state.brand.cachedBrand.tabs
          const result = tabs.filter((item) => {
            return item.alias === 'news'
          })
          if(!result[0]) {
            return next({ name: '404' })
          } else if(routeTo.params.categoryAlias) {
            const children = result[0].children.some((item) => {
                return item.alias === routeTo.params.categoryAlias
            })
            if (!children) return next({ name: '404' })
          }
          const { page = 1 } = routeTo.query
          const params = {
            brand_alias: [routeTo.params.brandAlias],
            limit: 10,
            page,
          }
          const [currentList] = await Promise.all([
            store.dispatch('article/fetchList', {
              contentAlias: routeTo.params.categoryAlias || 'promotion',
              params
            })
          ])
          routeTo.params.currentList = currentList.items;
          routeTo.params.featured = currentList.featured;
          routeTo.params.pagination = currentList.pagination;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
          // routeTo.params.breadcrumbTitle =''

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-最新消息'
    },
    props: (route) => ({
      currentList: route.params.currentList,
      featured: route.params.featured,
      pagination: route.params.pagination,
    })
  },
  // 代理品牌 品牌新訊/促銷訊息 內容頁
  {
    path: '/product/brand/:brandAlias/news/:categoryAlias/:newsAlias',
    name: 'brand-news-item',
    component: () => import('@views/Brand/News/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brandAlias, categoryAlias, newsAlias } = routeTo.params

          const [currentBrand, currentItem] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: brandAlias
            }),
            store.dispatch('article/fetchItem', {
              contentType: categoryAlias,
              brand: brandAlias,
              alias: newsAlias
            })
          ])
          if(currentItem.status === "ITEM_INSUFFICIENT_PERMISSION_VIEW") {
            await store.dispatch('auth/fetchUser')
            alert(`此頁面為經銷商會員限定觀看\n若你想成為經銷商會員，請與我們洽詢`);
            window.history.back();
          } else {
            routeTo.params.defaultValue = currentItem.items
          }
          routeTo.params.breadcrumbLevel3Title = currentItem.items.brands[0].title;
          routeTo.params.breadcrumbLevel4Title = routeTo.params.categoryAlias === 'bulletin' ? '品牌新訊' : '促銷訊息'

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '最新消息'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    })
  },
  // 代理品牌 成功案例 列表頁
  {
    path: '/product/brand/:brandAlias/case',
    name: 'brand-case-list',
    component: () => lazyLoadView(import('@views/Brand/Case/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('brand/fetchBrand', {
            brandAlias: routeTo.params.brandAlias
          })
          const tabs = store.state.brand.cachedBrand.tabs
          const result = tabs.some((item) => {
            return item.alias === 'case'
          })
          if(!result) return next({ name: '404' })
          const { industryCategory, query, page = 1 } = routeTo.query
          const params = {
            search: query || undefined,
            brand_alias: [routeTo.params.brandAlias],
            industry_category_alias: industryCategory
              ? [industryCategory]
              : undefined,
            limit: 10,
            page,
          }
          const [currentList, options] = await Promise.all([
            store.dispatch('article/fetchList', {
              contentAlias: 'case',
              params
            }),
            store.dispatch('category/fetchCategroy', {
              types: ['industry_category'],
              brand_alias: routeTo.params.brandAlias,
              content_type: 'case'
            })
          ])
          routeTo.params.currentList = currentList.items;
          routeTo.params.pagination = currentList.pagination;
          routeTo.params.options = options.industry_category
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-成功案例列表',
    },
    props: (route) => ({
      currentList: route.params.currentList,
      pagination: route.params.pagination,
      industryCategory: route.params.options,
    })
  },
  // 代理品牌 成功案例 內容頁
  {
    path: '/product/brand/:brandAlias/case/:caseAlias',
    name: 'brand-case-item',
    component: () => import('@views/Brand/Case/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brandAlias, categoryAlias, caseAlias } = routeTo.params

          const [currentBrand, currentItem] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: brandAlias
            }),
            store.dispatch('article/fetchItem', {
              contentType: 'case',
              alias: caseAlias,
              brand: brandAlias,
            })
          ])

          routeTo.params.defaultValue = currentItem.items;
          // routeTo.params.breadcrumbTitle = currentItem.title;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '成功案例'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    })
  },
  // 代理品牌 檔案下載 列表頁
  {
    path: '/product/brand/:brandAlias/file',
    name: 'brand-file',
    component: () => lazyLoadView(import('@views/Brand/File/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          /* const { categoryAlias, query, month, page = 1 } = routeTo.query;

          const params = {
            contentType: 'file',
            search: query || undefined,
            brand_alias: routeTo.params.brandAlias,
            categoryAlias: categoryAlias || undefined,
            search_date: month || undefined,
            limit: 10,
            page,
          }; */

          /* const [currentBrand, currentList, options] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            }),
            store.dispatch('global/searchFile', params),
            store.dispatch('option/fetchOptionList', {
              types: ['download_file_category'],
              useCached: true
            })
          ]) */

          // routeTo.params.currentList = currentList.items;
          // routeTo.params.pagination = currentList.pagination;
          await store.dispatch('brand/fetchBrand', {
            brandAlias: routeTo.params.brandAlias
          })
          const tabs = store.state.brand.cachedBrand.tabs
          const result = tabs.some((item) => {
            return item.alias === 'file'
          })
          if(!result) return next({ name: '404' })
          const [options] = await Promise.all([
            store.dispatch('option/fetchOptionList', {
              types: ['download_file_category'],
              useCached: true
            })
          ])
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-檔案下載'
      
    },
    props: (route) => ({
      // currentList: route.params.currentList,
      // pagination: route.params.pagination,
    })
  },
  // 代理品牌 產品影片 列表頁
  {
    path: '/product/brand/:brandAlias/video',
    name: 'brand-video-list',
    component: () => lazyLoadView(import('@views/Brand/Video/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('brand/fetchBrand', {
          brandAlias: routeTo.params.brandAlias
        })
        const tabs = store.state.brand.cachedBrand.tabs
        const result = tabs.some((item) => {
          return item.alias === 'video'
        })
        if(!result) return next({ name: '404' })
        try {
          const { query, month, page = 1 } = routeTo.query
          const params = {
            search: query || undefined,
            brand_alias: [routeTo.params.brandAlias],
            search_date: month || undefined,
            limit: 9,
            page,
          }
          const [currentList] = await Promise.all([
            store.dispatch('article/fetchList', {
              contentAlias: 'video',
              params
            })
          ])
          routeTo.params.featured = currentList.featured;
          routeTo.params.currentList = currentList.items;
          routeTo.params.pagination = currentList.pagination;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-影片專區列表'
    },
    props: (route) => ({
      currentList: route.params.currentList,
      featured: route.params.featured,
      pagination: route.params.pagination,
    })
  },
  // 代理品牌 產品影片 內容頁
  {
    path: '/product/brand/:brandAlias/video/:videoAlias',
    name: 'brand-video-item',
    component: () => import('@views/Brand/Video/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brandAlias, videoAlias } = routeTo.params

          const [currentBrand, currentItem] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: brandAlias
            }),
            store.dispatch('article/fetchItem', {
              contentType: 'video',
              alias: videoAlias,
              brand: brandAlias,
            })
          ])

          routeTo.params.defaultValue = currentItem.items
          routeTo.params.breadcrumbLevel3Title = currentItem.items.brands[0].title;
          // routeTo.params.breadcrumbTitle = item.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '影片專區'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    })
  },
  // 共同供應契約採購
  {
    path: '/product/BOT',
    name: 'bot-list',
    component: () => lazyLoadView(import('@views/BOT/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { fileCategory, query, month, page = 1 } = routeTo.query
          const params = {
            contentType: 'contract',
            search: query || undefined,
            categoryAlias: fileCategory || undefined,
            search_date: month || undefined,
            limit: 10,
            page,
            orderBy: 'publish_up',
          }
          const [{ items, pagination }, contractOption] = await Promise.all([
            store.dispatch('global/searchFile', params),
            store.dispatch('option/fetchOptionList', {
              types: ['contract_file_category'],
              useCached: true
            })
          ])
          routeTo.params.list = items
          routeTo.params.pagination = pagination

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "bot",
      title: '共同供應契約採購'
    },
    props: (route) => ({
      list: route.params.list,
      pagination: route.params.pagination,
    })
  },
]
